import Axios from '../axios-instance';

const QualityCertificateRequestsAPI = {
  getDataGrid: body => {
    return Axios.post('/QualityCertificateRequests/Get', body).then(({ data }) => data);
  },
  
 saveCertificate: body => {
    return Axios.post('/QualityCertificateRequests/saveCertificate', body).then(({ data }) => data);
  },

  getFile: (id, fileName) => {
    return Axios.get(`/QualityCertificateRequests/${id}/${fileName}`).then(({ data }) => data);
  },

  exportToExcel: body => {
    return Axios.post('/QualityCertificateRequests/exportToExcel', body, { responseType: 'arraybuffer' }).then(({ data }) => data);
  },

  deleteFile: body => {
    return Axios.post(`/QualityCertificateRequests/deleteFile`, body).then(({ data }) => data);
  },

  searchByUploadCode: body =>{
    return Axios.post('/QualityCertificateRequests/SearchByUploadCode', body).then(({ data }) => data);
  }
};

export default QualityCertificateRequestsAPI;
